import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';

// Initialize PostHog BEFORE React
posthog.init('phc_QfHvQSXzEMEiQ8ihy6TpvmEY1WKicjibUBO7gLkp4HN', {
  api_host: 'https://eu.i.posthog.com',
  autocapture: true,
  capture_pageview: false,
  loaded: (posthog) => {
    // Identify Telegram user as soon as PostHog is ready
    const user = window.Telegram?.WebApp?.initDataUnsafe?.user;
    if (user?.id) {
      posthog.identify(String(user.id), {
        username: user.username,
        first_name: user.first_name,
        language_code: user.language_code,
      });
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);